module.exports = __webpack_public_path__ + "be.svg?5739940da79d5fa8e595e64c05669c2a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/be.svg
// module id = 1248
// module chunks = 0